<template>
    <component :is="as" :class="props.class">
        <span ref="placeholderEl" :class="props.placeholderClass"></span>
        <slot></slot>
        <span
            :class="
                cn('border-brand-primaryBlue animate-pulse border-r-[3px] ps-px', props.caretClass)
            "></span>
    </component>
</template>

<script lang="ts" setup>
import { useTypewriter } from './composables'
import { onMounted } from 'vue'
import { cn } from '@/lib/utils'

interface Props {
    as?: string
    labels?: string[]
    keyInterval?: number
    deleteInterval?: number
    postTypingPause?: number
    preTypingPause?: number
    caretClass?: string
    placeholderClass?: string
    class?: string
}

const props = withDefaults(defineProps<Props>(), {
    as: 'p',
    // Hardcode a set of words for now
    labels: () => ['https://www.example.com', 'https://w.e.com'],
})

const {
    placeholderEl,
    start,
    words,
    typeInterval,
    eraseInterval,
    fullTextPauseInterval,
    pauseBeforeStartInterval,
} = useTypewriter()

onMounted(() => {
    if (props.labels.length > 0) {
        words.value = props.labels
        if (props.keyInterval) typeInterval.value = props.keyInterval
        if (props.deleteInterval) eraseInterval.value = props.deleteInterval
        if (props.postTypingPause) fullTextPauseInterval.value = props.postTypingPause
        if (props.preTypingPause) pauseBeforeStartInterval.value = props.preTypingPause
        start()
    }
})
</script>
